"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

exports.StyledSection = React.forwardRef(function (_a, ref) {
  var _b;

  var context = _a.context,
      maxSize = _a.maxSize,
      minSize = _a.minSize,
      flexGrow = _a.flexGrow,
      flexShrink = _a.flexShrink,
      flexBasis = _a.flexBasis,
      style = _a.style,
      props = __rest(_a, ["context", "maxSize", "minSize", "flexGrow", "flexShrink", "flexBasis", "style"]);

  return React.createElement("div", __assign({}, props, {
    ref: ref,
    style: __assign((_b = {
      overflow: 'hidden'
    }, _b[context.vertical ? 'maxHeight' : 'maxWidth'] = maxSize, _b[context.vertical ? 'minHeight' : 'minWidth'] = minSize, _b.flexGrow = flexGrow, _b.flexShrink = flexShrink, _b.flexBasis = flexBasis, _b), style)
  }));
});